import React from 'react';
import { CookiebotPage } from '../c/Cookiebot.js';
export default (props) => {
	return <CookiebotPage/>;
};



// WEBPACK FOOTER //
// ./src/p/Cookies.js